import { useCallback } from "react";
import { useAppSelector } from "redux/hooks";
import selectEntity from "module/staff/redux/selector/selectEntity";
import { EntityType } from "module/entity/types";
import { MyTrainingCustomInterface } from "module/trainingCustom/types";

interface Result {
  getReadableIdentifier: (id: string) => string;
}

const useMyTrainingCustomReadableIdentifier = (): Result => {
  const selectEntityHelper = useAppSelector(selectEntity);
  const getReadableIdentifier = useCallback(
    (id: string): string => {
      const myEntity = selectEntityHelper({
        id,
        type: EntityType.trainingCustom,
      }) as MyTrainingCustomInterface;
      return myEntity.data.name;
    },
    [selectEntityHelper]
  );

  return {
    getReadableIdentifier,
  };
};

export default useMyTrainingCustomReadableIdentifier;
